<div class="font-list">
  <div
    class="font-button"
    [attr.data-test-id]="'font_' + font"
    *ngFor="let font of fonts; let i = index"
    [class.active]="font === (currentFont || defaultFont)"
    (click)="onSelected.emit(font)"
  >
    <div class="font-image" [style.-webkit-mask-image]="imageLinks[i]" [style.mask-image]="imageLinks[i]"></div>
    <app-svg src="/assets/icons/check.svg" *ngIf="font === (currentFont || defaultFont)" class="some-check"></app-svg>
  </div>
</div>

<div class="reset-button" *ngIf="currentFont && allowFontReset">
  <app-button-menu-item
    name="reset-font"
    location="font-selection-menu"
    [color]="'simple'"
    icon="undo"
    [fullWidth]="true"
    (onClick)="onSelected.emit(undefined)"
  >
    <span>Reset Font</span>
  </app-button-menu-item>
</div>

<div class="reset-button" *ngIf="allowRemoveOverrides">
  <app-button-menu-item
    name="remove-overrides"
    location="font-selection-menu"
    [color]="'simple'"
    icon="undo"
    [fullWidth]="true"
    (onClick)="onRemoveOverrides.emit()"
  >
    <span>Remove overrides</span>
  </app-button-menu-item>
</div>
